var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-container"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"logo",on:{"click":function($event){return _vm.$emit('action', 'full-screen')}}},[_c('div',{staticClass:"logo-text"},[_vm._v("营造云智慧工地")])]),_c('div',{staticClass:"scroll"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }